import { Card, CardContent, Tab, Tabs } from '@mui/material'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslate } from 'react-admin'
import { useNavigate, useParams } from 'react-router-dom'
import { useUserStore } from '../../stores/useUserStore'
import { Forbidden } from '../Forbidden'
import { AutomatedMonetization } from './AutomatedMonetization'
import { AutomatedTranslation } from './AutomatedTranslation'
import styles from './AutomatedTreatments.module.scss'
import { MonetizationPatterns } from './MonetizationPatterns'

type TabOption = 'monetization' | 'translation' | 'patterns'

export const AutomatedTreatments = () => {
  const translate = useTranslate()
  const navigate = useNavigate()
  const params = useParams()
  const userStore = useUserStore()

  const [tab, setTab] = useState<TabOption>(
    (params.automatedTreatmentTab as TabOption) ?? 'translation',
  )

  useEffect(() => {
    navigate(`/automated-treatments/${tab}`)
  }, [navigate, tab])

  const onTabChange = useCallback(
    (tabValue: TabOption) => {
      setTab(tabValue)
      navigate(`/automated-treatments/${tabValue}`)
    },
    [navigate],
  )

  const automatedTranslation = useMemo(() => {
    if (!userStore.isAuthorised('auto_translation.read')) {
      return <Forbidden permission="auto_translation.read" />
    }

    return <AutomatedTranslation />
  }, [userStore])
  const automatedMonetization = useMemo(() => {
    if (!userStore.isAuthorised('auto_monetization.read')) {
      return <Forbidden permission="auto_monetization.read" />
    }

    return <AutomatedMonetization />
  }, [userStore])
  const monetizationPatterns = useMemo(() => {
    if (!userStore.isAuthorised('monetization_patterns.edit')) {
      return <Forbidden permission="monetization_patterns.edit" />
    }

    return <MonetizationPatterns />
  }, [userStore])

  return (
    <Card>
      <CardContent className={styles.container}>
        <Tabs value={tab} onChange={(_, v) => onTabChange(v)}>
          <Tab value="translation" label={translate('pages.automatedTreatments.translation')} />
          <Tab value="monetization" label={translate('pages.automatedTreatments.monetization')} />
          <Tab value="patterns" label={translate('pages.automatedTreatments.patterns')} />
        </Tabs>
        {tab === 'translation' && automatedTranslation}
        {tab === 'monetization' && automatedMonetization}
        {tab === 'patterns' && monetizationPatterns}
      </CardContent>
    </Card>
  )
}
